/* CCH cart drawer. Fills snippets/cch-cart.liquid from /cart.js. No app. */
(function () {
  if (customElements.get('cch-cart-drawer')) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HDR = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CCH-Cart': '1' };
  var RX = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var lastGesture = 0;
  ['pointerdown', 'keydown', 'submit', 'click'].forEach(function (t) {
    document.addEventListener(t, function () { lastGesture = Date.now(); }, true);
  });

  function money(c) {
    c = Math.round(c || 0);
    var d = c / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function post(path, body) {
    return fetch(ROOT + path, { method: 'POST', headers: HDR, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Something went wrong'); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function isGift(i) {
    var p = i.properties || {};
    if (/freegift|sca_clone/i.test(i.handle || '')) return true;
    for (var k in p) if (/bogos|freegift|_fg_|sca_/i.test(k)) return true;
    return i.final_line_price === 0 && /🎁|free gift/i.test(i.product_title || i.title || '');
  }
  function giftTitle(t) {
    return String(t || '').replace(/^\s*🎁\s*/, '').replace(/\s*\(100% off\)\s*/i, ' ').trim();
  }
  function shownProps(p, grouped) {
    var out = [];
    for (var k in p || {}) {
      if (!p[k] || k.charAt(0) === '_' || (grouped && k === 'For')) continue;
      out.push(String(p[k]).toLowerCase() === 'yes' ? k : k + ': ' + p[k]);
    }
    return out;
  }

  class CchCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      var q = this.querySelector.bind(this);
      this.panel = q('.cch-cart__panel');
      this.el = {
        count: q('[data-count]'), ship: q('[data-ship]'), shipMsg: q('[data-ship-msg]'), fill: q('[data-ship-fill]'),
        empty: q('[data-empty]'), lines: q('[data-lines]'), video: q('[data-video]'), recs: q('[data-recs]'), recList: q('[data-rec-list]'),
        extras: q('[data-extras]'), note: q('[data-note]'), noteStatus: q('[data-note-status]'), discForm: q('[data-disc-form]'),
        discInput: q('[data-disc-input]'), discMsg: q('[data-disc-msg]'), codes: q('[data-codes]'), foot: q('[data-foot]'),
        save: q('[data-save]'), saveAmt: q('[data-save-amt]'), total: q('[data-total]'), shipnote: q('[data-shipnote]'), live: q('[data-live]'),
        checkout: q('[data-checkout]')
      };
      this.goal = parseInt(this.dataset.goal, 10) || 30000;
      this.onCart = this.dataset.onCart === 'true';
      this.videoId = parseInt(this.dataset.videoId, 10) || 0;
      this.videoPrice = parseInt(this.dataset.videoPrice, 10) || 0;
      this.cart = null; this.wasDone = null; this.recCache = {}; this.seq = 0;
      this.shopper = this.whoIsThis();
      this.setAttribute('data-cch-shopper', this.shopper);
      document.documentElement.setAttribute('data-cch-shopper', this.shopper);
      this.titleEl = q('#cch-cart-title');
      if (this.shopper === 'returning') {
        var nm = this.dataset.firstName;
        var t = nm ? (this.dataset.welcome || 'Welcome back, [name]').replace('[name]', nm) : (this.dataset.welcomePlain || 'Welcome back');
        this.titleEl.firstChild.nodeValue = t + ' ';
      }
      try { var tj = document.getElementById('cch-cart-try'); this.tryList = tj ? JSON.parse(tj.textContent) : []; } catch (e) { this.tryList = []; }
      this.bind();
      this.hookNetwork();
      var self = this;
      var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      idle(function () { self.refresh(); });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
      document.addEventListener('cch:cart-cleaned', function () { self.refresh(); });
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        try { subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'cch-cart') self.refresh(); }); } catch (e) {}
      }
      window.CCHCart = { open: function (o) { return self.open(o); }, close: function () { self.close(); }, refresh: function () { return self.refresh(); } };
    }

    /* New vs returning. Logged in: decided in Liquid (orders_count > 0). Guests: been to checkout before,
       or visited in an earlier browser session (localStorage). */
    whoIsThis() {
      // A "visit" starts after 30+ min with no activity on the store (localStorage timestamp shared by all tabs),
      // so a first-time shopper with two tabs open is still new. Logged-in customers come from Liquid (data-shopper-server).
      var srv = this.dataset.shopperServer;
      var ls = null; try { ls = window.localStorage; } catch (e) {}
      var visits = 0, co = false, GAP = 30 * 60 * 1000, now = Date.now();
      if (ls) {
        try {
          visits = parseInt(ls.getItem('cch_vis') || '0', 10) || 0;
          var last = parseInt(ls.getItem('cch_last') || '0', 10) || 0;
          var start = parseInt(ls.getItem('cch_vstart') || '0', 10) || 0;
          if (!last || now - last > GAP || !start) { visits++; start = now; ls.setItem('cch_vis', String(visits)); ls.setItem('cch_vstart', String(start)); }
          ls.setItem('cch_last', String(now));
          // checkout counts only if it happened in an earlier visit
          var cot = parseInt(ls.getItem('cch_co_at') || '0', 10) || 0;
          co = cot > 0 && cot < start;
          if (srv === 'returning' && !cot) ls.setItem('cch_co_at', '1');
        } catch (e) {}
        this.bumpActivity();
      }
      if (srv) return srv;
      return co || visits > 1 ? 'returning' : 'new';
    }

    bumpActivity() {
      // keep the visit alive while the shopper is active (throttled to once a minute)
      if (this._bump) return; this._bump = true;
      var t = 0, tick = function () {
        var n = Date.now(); if (n - t < 60000) return; t = n;
        try { localStorage.setItem('cch_last', String(n)); } catch (e) {}
      };
      ['pointerdown', 'keydown', 'scroll'].forEach(function (ev) { window.addEventListener(ev, tick, { passive: true }); });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { t = 0; tick(); } });
    }

    /* --- Craft product-form / quick-add compatibility --- */
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this.opener = el; }
    renderContents() { this.open({ refresh: true }); }

    bind() {
      var self = this;
      this.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cch-close]'); if (t) { e.preventDefault(); self.close(); return; }
        var b = e.target.closest('[data-act]'); if (!b) return;
        e.preventDefault();
        var a = b.dataset.act, key = b.dataset.key;
        if (a === 'inc' || a === 'dec') self.setQty(key, parseInt(b.dataset.q, 10) + (a === 'inc' ? 1 : -1));
        else if (a === 'rm') self.setQty(key, 0);
        else if (a === 'video') self.toggleVideo();
        else if (a === 'rec') self.addRec(b);
        else if (a === 'uncode') self.removeCode(b.dataset.code);
        else if (a === 'gift') self.pickGift();
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
        if (e.key !== 'Tab') return;
        var f = Array.prototype.filter.call(self.panel.querySelectorAll('a[href],button:not([disabled]),input,textarea,summary,[tabindex]:not([tabindex="-1"])'), function (n) {
          return n.offsetParent !== null || n === document.activeElement;
        });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === self.panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      // cart icon opens the drawer (the /cart page keeps its normal link)
      document.addEventListener('click', function (e) {
        var ic = e.target.closest && e.target.closest('#cart-icon-bubble, a.header__icon--cart, [data-cch-open-cart]');
        if (!ic || self.onCart || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault(); e.stopImmediatePropagation(); self.opener = ic; self.open({ refresh: true });
      }, true);
      // note: save while typing (debounced) and on blur
      var nt;
      this.el.note.addEventListener('input', function () { clearTimeout(nt); self.el.noteStatus.textContent = ''; nt = setTimeout(function () { self.saveNote(); }, 700); });
      this.el.note.addEventListener('blur', function () { clearTimeout(nt); self.saveNote(); });
      this.el.discForm.addEventListener('submit', function (e) { e.preventDefault(); self.applyCode(); });
      this.el.checkout.addEventListener('click', function () {
        self.el.checkout.setAttribute('aria-busy', 'true');
        try { localStorage.setItem('cch_co_at', String(Date.now())); localStorage.setItem('cch_last', String(Date.now())); } catch (e) {}
      });
      // Rewards opens Smile's panel (#smile-home); close the drawer first so the panel is on top
      var rw = this.querySelector('[data-rewards]');
      if (rw) rw.addEventListener('click', function (e) {
        e.preventDefault(); self.close();
        setTimeout(function () { if (location.hash === '#smile-home') history.replaceState(null, '', location.pathname + location.search); location.hash = 'smile-home'; }, 60);
      });
      // BOGOS tells the page when it changes the cart; follow along
      ['fg-cart:auto-updated', 'fg-gifts:added', 'fg-gifts:updated', 'bogos:cart-change', 'fg-cart:end-process'].forEach(function (ev) {
        window.addEventListener(ev, function () { self.refreshSoon(); });
        document.addEventListener(ev, function () { self.refreshSoon(); });
      });
    }

    /* Watch cart requests from the theme, BOGOS and other scripts so the drawer stays in sync. */
    hookNetwork() {
      var self = this, of = window.fetch;
      function seen(url, method, ok, isAdd) {
        if (!ok) return;
        self.refreshSoon();
        if (isAdd && !self.onCart && Date.now() - lastGesture < 6000) self.open({ refresh: false });
      }
      window.fetch = function (input, init) {
        var url = (typeof input === 'string' ? input : (input && input.url)) || '';
        var h = (init && init.headers) || (input && input.headers);
        var mine = h && (h['X-CCH-Cart'] || (h.get && h.get('X-CCH-Cart')));
        var p = of.apply(this, arguments);
        if (!mine && RX.test(url)) {
          var isAdd = /\/cart\/add/.test(url);
          p.then(function (r) { seen(url, 'POST', r && r.ok, isAdd); }, function () {});
        }
        return p;
      };
      var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { this.__cchCartU = String(u || ''); return oo.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        var x = this, u = x.__cchCartU || '';
        if (RX.test(u)) x.addEventListener('loadend', function () { seen(u, 'POST', x.status >= 200 && x.status < 300, /\/cart\/add/.test(u)); });
        return os.apply(this, arguments);
      };
    }

    refreshSoon() {
      var self = this;
      clearTimeout(this._rs); this._rs = setTimeout(function () { self.refresh(); }, 200);
      // BOGOS adds/removes its gift a moment later; look again so it shows without a reload.
      clearTimeout(this._rs2); this._rs2 = setTimeout(function () { self.refresh(); }, 1800);
      clearTimeout(this._rs3); this._rs3 = setTimeout(function () { self.refresh(); }, 4500);
    }

    refresh() {
      var self = this, n = ++this.seq;
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json', 'X-CCH-Cart': '1' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (n === self.seq) self.render(c); return c; })
        .catch(function () {});
    }

    open(o) {
      o = o || {};
      if (this.onCart) { return; }
      var self = this;
      if (!this.classList.contains('is-open')) {
        if (!this.opener) this.opener = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('cch-cart-open');
        document.body.classList.add('cch-cart-open');
        requestAnimationFrame(function () { self.querySelector('.cch-cart__x').focus({ preventScroll: true }); });
      }
      if (o.refresh !== false || !this.cart) return this.refresh(); else this.refreshSoon();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('cch-cart-open');
      document.body.classList.remove('cch-cart-open');
      var o = this.opener; this.opener = null;
      if (o && o.focus && document.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
    }

    say(t) { this.el.live.textContent = ''; var l = this.el.live; setTimeout(function () { l.textContent = t; }, 50); }

    /* ---------------- render ---------------- */
    render(c) {
      this.cart = c;
      var self = this, el = this.el, items = c.items || [];
      var vid = this.videoId;
      var cartVideo = null, pdpVideo = false, real = 0;
      items.forEach(function (i) {
        var p = i.properties || {};
        if (vid && i.variant_id === vid && p._cch_cart_video) cartVideo = i;
        else if (vid && i.variant_id === vid && p._cch_parent) pdpVideo = true;
        if (!(vid && i.variant_id === vid) && !isGift(i)) real++;
      });
      // a cart-level video with nothing else to film goes away on its own
      if (cartVideo && real === 0) { this.setQty(cartVideo.key, 0); }

      var n = c.item_count || 0;
      el.count.textContent = n ? '(' + n + ')' : '';
      this.updateBubble(n);

      // free shipping bar
      var tot = c.total_price || 0, left = this.goal - tot, done = left <= 0 && n > 0;
      el.fill.style.width = Math.max(0, Math.min(100, (tot / this.goal) * 100)) + '%';
      el.ship.classList.toggle('is-done', done);
      if (!n) el.shipMsg.textContent = 'Free shipping on orders over ' + money(this.goal);
      else if (done) el.shipMsg.innerHTML = '✨ <strong>You\'ve got free shipping!</strong>';
      else el.shipMsg.innerHTML = 'You\'re <strong>' + esc(money(left)) + '</strong> away from free shipping';
      if (done && this.wasDone === false) {
        el.ship.classList.remove('is-cheer'); void el.ship.offsetWidth; el.ship.classList.add('is-cheer');
        this.say('You\'ve got free shipping.');
      }
      this.wasDone = done;

      el.empty.hidden = n > 0;
      el.foot.hidden = n === 0;
      el.extras.hidden = n === 0;

      // lines: scoops first in cart order, add-ons (_cch_parent) grouped under their scoop
      var byKey = {}, kids = {}, top = [];
      items.forEach(function (i) { var k = i.properties && i.properties._cch_key; if (k) byKey[k] = i; });
      items.forEach(function (i) {
        if (i === cartVideo) return;
        var par = i.properties && i.properties._cch_parent;
        if (par && byKey[par]) (kids[par] = kids[par] || []).push(i); else top.push(i);
      });
      // gifts sit right under the paid items
      top.sort(function (a, b) { return (isGift(a) ? 1 : 0) - (isGift(b) ? 1 : 0); });
      el.lines.innerHTML = top.map(function (i) { return self.lineHTML(i, kids[(i.properties || {})._cch_key] || []); }).join('');

      // video switch
      if (vid && real > 0 && !(pdpVideo && !cartVideo)) {
        var on = !!cartVideo;
        el.video.innerHTML = '<button type="button" class="cch-vid" role="switch" aria-checked="' + on + '" data-act="video">' +
          (this.dataset.videoImg ? '<img src="' + esc(this.dataset.videoImg) + '" alt="" width="44" height="44" loading="lazy">' : '') +
          '<span class="cch-vid__t"><b>Add Video?</b><small>Add a custom video of your order!</small></span>' +
          '<span class="cch-vid__p">+' + esc(money(this.videoPrice)) + '</span><span class="cch-sw" aria-hidden="true"></span></button>';
      } else if (vid && real > 0 && pdpVideo) {
        el.video.innerHTML = '<p class="cch-vid-note">🎥 Your order video is in the cart.</p>';
      } else el.video.innerHTML = '';

      // note
      if (document.activeElement !== el.note) el.note.value = c.note || '';
      // discount codes
      var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; });
      el.codes.innerHTML = codes.map(function (d) {
        return '<li class="cch-code"><span>' + esc(d.code) + '</span><button type="button" data-act="uncode" data-code="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '"><svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></li>';
      }).join('');

      // totals
      var saved = c.total_discount || 0;
      el.save.hidden = saved <= 0; el.saveAmt.textContent = '−' + money(saved);
      el.total.textContent = money(tot);
      el.shipnote.textContent = done ? 'Free shipping. Taxes at checkout.' : 'Shipping and taxes at checkout.';
      this.renderGift(items);
      this.renderTry(items);
      this.loadRecs(items, real);
    }

    /* Free Galactic gift (BOGOS offer "C/E/D/S For Galactic"): Celestial, Ethereal, Divine or Source size qualifies. */
    renderGift(items) {
      var box = this.el.gift || (this.el.gift = this.querySelector('[data-gift]'));
      if (!box) return;
      if (!this.dataset.giftOn) { box.hidden = true; return; }
      var scoops = items.filter(function (i) { return !isGift(i) && /scoop/i.test(i.product_type || ''); });
      var has = items.some(isGift);
      var ok = scoops.some(function (i) { return /celestial|ethereal|divine|source/i.test(i.variant_title || ''); });
      var close = !ok && scoops.find(function (i) { return /galactic|lunar/i.test(i.variant_title || ''); });
      var h = '';
      if (has) h = '<span class="cch-gift__i" aria-hidden="true">🎁</span><span>' + esc(this.dataset.giftHave) + '</span>';
      else if (ok) h = '<span class="cch-gift__i" aria-hidden="true">🎁</span><span>' + esc(this.dataset.giftOk) + '</span>' +
        (this.canPickGift() ? '<button type="button" class="cch-gift__b" data-act="gift">Pick my gift</button>' : '');
      else if (close) h = '<span class="cch-gift__i" aria-hidden="true">🎁</span><span>' + esc(this.dataset.giftClose) +
        ' <a href="' + esc(close.url) + '">Change size</a></span>';
      box.innerHTML = h; box.hidden = !h; box.classList.toggle('is-have', has);
    }
    canPickGift() { return !!document.querySelector('#freegifts-main-popup-container'); }
    pickGift() {
      // BOGOS shows its gift picker when it hears its own "show slider" event
      var c = document.querySelector('#freegifts-main-popup-container');
      ['fg-gifts:show-slider'].forEach(function (ev) { try { window.dispatchEvent(new CustomEvent(ev)); document.dispatchEvent(new CustomEvent(ev)); } catch (e) {} });
      if (c) { c.classList.add('sca-is-visible-fg'); c.style.display = ''; }
    }

    /* Returning shoppers: one pick from a collection they haven't bought from and don't have in the cart. */
    renderTry(items) {
      var sec = this.querySelector('[data-try]'); if (!sec) return;
      if (this.shopper !== 'returning' || !this.tryList.length) { sec.hidden = true; return; }
      var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });
      var t = this.tryList.find(function (c) { return !c.ids.some(function (id) { return inCart[id]; }); });
      if (!t) { sec.hidden = true; return; }
      var p = t.p;
      this.querySelector('[data-try-card]').innerHTML = '<div class="cch-rec cch-try__card"><img src="' + esc(p.i) + '" alt="" width="52" height="52" loading="lazy">' +
        '<span style="min-width:0"><a class="cch-rec__t" href="' + esc(p.u) + '">' + esc(p.t) + '</a><span class="cch-rec__p">' + esc(t.c) + ' · ' + (p.v ? 'From ' : '') + esc(money(p.pr)) + '</span></span>' +
        '<a class="cch-rec__b" href="' + esc(t.cu) + '" aria-label="See ' + esc(t.c) + '">See all</a></div>';
      sec.hidden = false;
    }

    lineHTML(i, subs) {
      var gift = isGift(i), p = i.properties || {};
      var title = gift ? giftTitle(i.product_title) : i.product_title;
      var vt = i.variant_title && !/default title/i.test(i.variant_title) ? i.variant_title : '';
      var meta = [vt].concat(shownProps(p, false)).filter(Boolean).join(' · ');
      var price = gift ? '<span>FREE</span>' :
        (i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '') + money(i.final_line_price);
      var url = gift ? '' : (i.url || '');
      var h = '<li class="cch-line' + (gift ? ' is-gift' : '') + '" data-line="' + esc(i.key) + '">' +
        (url ? '<a class="cch-line__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' : '<span class="cch-line__img">') +
        (i.image ? '<img src="' + esc(img(i.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') + (url ? '</a>' : '</span>') +
        '<div class="cch-line__info">' + (url ? '<a class="cch-line__title" href="' + esc(url) + '">' + esc(title) + '</a>' : '<span class="cch-line__title">' + esc(title) + '</span>') +
        (meta ? '<p class="cch-line__meta">' + esc(meta) + '</p>' : '') +
        (gift ? '<span class="cch-pill">Free gift</span>' :
          '<div class="cch-line__ctrl"><div class="cch-qty" role="group" aria-label="Quantity for ' + esc(title) + '">' +
          '<button type="button" data-act="dec" data-key="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="One less"' + (i.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span aria-live="polite">' + i.quantity + '</span>' +
          '<button type="button" data-act="inc" data-key="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="One more">+</button></div>' +
          '<button type="button" class="cch-rm" data-act="rm" data-key="' + esc(i.key) + '" aria-label="Remove ' + esc(title) + '">Remove</button></div>') +
        '</div><div class="cch-line__price">' + price + '</div>';
      if (subs.length) {
        h += '<ul class="cch-line__subs" role="list" aria-label="Add-ons for ' + esc(title) + '">' + subs.map(function (s) {
          var sm = [s.variant_title && !/default title/i.test(s.variant_title) ? s.variant_title : ''].concat(shownProps(s.properties, true)).filter(Boolean).join(' · ');
          return '<li class="cch-sub" data-line="' + esc(s.key) + '">' + (s.image ? '<img src="' + esc(img(s.image, 80)) + '" alt="" width="36" height="36" loading="lazy">' : '<span></span>') +
            '<span class="cch-sub__t">' + esc(s.product_title) + (s.quantity > 1 ? ' × ' + s.quantity : '') + (sm ? '<small>' + esc(sm) + '</small>' : '') + '</span>' +
            '<span class="cch-sub__r">' + money(s.final_line_price) + '<button type="button" class="cch-sub__x" data-act="rm" data-key="' + esc(s.key) + '" aria-label="Remove ' + esc(s.product_title) + '"><svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button></span></li>';
        }).join('') + '</ul>';
      }
      return h + '<p class="cch-line__err" data-err hidden></p></li>';
    }

    updateBubble(n) {
      document.querySelectorAll('#cart-icon-bubble').forEach(function (ic) {
        var b = ic.querySelector('.cart-count-bubble');
        if (!n) { if (b) b.remove(); return; }
        if (!b) {
          b = document.createElement(ic.classList.contains('cch-lp-cart') ? 'span' : 'div');
          b.className = 'cart-count-bubble' + (ic.classList.contains('cch-lp-cart') ? ' cch-lp-count' : '');
          ic.appendChild(b);
        }
        b.innerHTML = '<span aria-hidden="true">' + (n < 100 ? n : '99+') + '</span><span class="visually-hidden">' + n + (n === 1 ? ' item' : ' items') + '</span>';
        if (ic.hasAttribute('aria-label')) ic.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      });
    }

    /* ---------------- actions ---------------- */
    busy(key, on) {
      this.querySelectorAll('[data-line="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]').forEach(function (n) { n.classList.toggle('is-busy', on); });
    }
    setQty(key, q) {
      var self = this, c = this.cart, line = c && c.items.find(function (i) { return i.key === key; });
      if (!line) return;
      q = Math.max(0, q);
      var upd = {}; upd[key] = q;
      // add-ons follow their scoop (same quantity, or removed with it)
      var k = line.properties && line.properties._cch_key;
      if (k) c.items.forEach(function (i) { if (i.properties && i.properties._cch_parent === k) upd[i.key] = q; });
      this.busy(key, true);
      return post('cart/update.js', { updates: upd }).then(function (cart) {
        self.render(cart); self.refreshSoon(); self.say(q ? 'Quantity updated' : 'Removed from cart');
        if (q > line.quantity) {
          var nl = cart.items.find(function (i) { return i.key === key; });
          if (nl && nl.quantity < q) self.lineErr(key, 'Only ' + nl.quantity + ' available right now.');
        }
      }).catch(function (e) { self.busy(key, false); self.lineErr(key, e.message); });
    }
    lineErr(key, msg) {
      var li = this.querySelector('[data-line="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"] [data-err]');
      if (li) { li.textContent = msg; li.hidden = false; }
    }
    toggleVideo() {
      var self = this, c = this.cart, b = this.querySelector('.cch-vid'); if (!c || !this.videoId) return;
      var cur = c.items.find(function (i) { return i.variant_id === self.videoId && i.properties && i.properties._cch_cart_video; });
      if (b) b.classList.add('is-busy');
      var p = cur ? post('cart/change.js', { id: cur.key, quantity: 0 })
                  : post('cart/add.js', { items: [{ id: this.videoId, quantity: 1, properties: { _cch_cart_video: 'Yes' } }] });
      p.then(function () { self.say(cur ? 'Video removed' : 'Video added'); return self.refresh(); })
       .catch(function () { if (b) b.classList.remove('is-busy'); self.say('Could not update the video. Try again.'); });
    }
    saveNote() {
      var self = this, v = this.el.note.value;
      if (!this.cart || v === (this.cart.note || '')) return;
      post('cart/update.js', { note: v }).then(function (c) { self.cart.note = c.note; self.el.noteStatus.textContent = 'Saved'; })
        .catch(function () { self.el.noteStatus.textContent = 'Could not save your note. Try again.'; });
    }
    codesNow() { return ((this.cart && this.cart.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }); }
    applyCode() {
      var self = this, el = this.el, code = (el.discInput.value || '').trim();
      el.discMsg.classList.remove('is-bad');
      if (!code) { el.discMsg.textContent = 'Type a code first.'; el.discMsg.classList.add('is-bad'); el.discInput.focus(); return; }
      var have = this.codesNow();
      if (have.some(function (x) { return x.toLowerCase() === code.toLowerCase(); })) { el.discMsg.textContent = 'That code is already on.'; return; }
      var btn = el.discForm.querySelector('button'); btn.setAttribute('aria-busy', 'true');
      el.discMsg.textContent = 'Checking…';
      post('cart/update.js', { discount: have.concat([code]).join(',') }).then(function (c) {
        var hit = (c.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (hit && hit.applicable) {
          el.discInput.value = ''; el.discMsg.textContent = 'Code added.'; self.render(c); self.refreshSoon();
        } else {
          el.discMsg.textContent = '"' + code + '" isn\'t a working code for this cart.'; el.discMsg.classList.add('is-bad');
          // take the dead code back off so it doesn't ride along to checkout
          return post('cart/update.js', { discount: have.join(',') }).then(function (c2) { self.render(c2); });
        }
      }).catch(function () {
        el.discMsg.textContent = 'Couldn\'t check that code right now. You can also enter it at checkout.'; el.discMsg.classList.add('is-bad');
      }).finally(function () { btn.removeAttribute('aria-busy'); });
    }
    removeCode(code) {
      var self = this, left = this.codesNow().filter(function (x) { return x !== code; });
      post('cart/update.js', { discount: left.join(',') }).then(function (c) { self.el.discMsg.textContent = 'Code removed.'; self.el.discMsg.classList.remove('is-bad'); self.render(c); self.refreshSoon(); })
        .catch(function () { self.el.discMsg.textContent = 'Couldn\'t remove that code. Try again.'; self.el.discMsg.classList.add('is-bad'); });
    }

    /* ---------------- goes well with ---------------- */
    loadRecs(items, real) {
      var self = this, el = this.el;
      var base = items.find(function (i) { return !isGift(i) && i.variant_id !== self.videoId && !(i.properties && i.properties._cch_parent); });
      if (!base || !real) { el.recs.hidden = true; return; }
      var inCart = {}; items.forEach(function (i) { inCart[i.product_id] = 1; });
      var pid = base.product_id;
      var go = function (list) {
        var picks = (list || []).filter(function (p) {
          return p.available && !inCart[p.id] && p.price > 0 && p.handle !== 'video' && !/freegift|sca_clone|gift-card/i.test(p.handle) &&
            !/🎁/.test(p.title);
        }).slice(0, 3);
        if (!picks.length) { el.recs.hidden = true; return; }
        el.recList.innerHTML = picks.map(function (p) {
          var vs = (p.variants || []).filter(function (v) { return v.available; });
          var one = (p.variants || []).length === 1 && vs.length === 1;
          var pr = (p.price_varies ? 'From ' : '') + money(p.price_min || p.price);
          var im = p.featured_image || (p.images && p.images[0]) || '';
          return '<li class="cch-rec"><img src="' + esc(img(im, 120)) + '" alt="" width="52" height="52" loading="lazy">' +
            '<span style="min-width:0"><a class="cch-rec__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="cch-rec__p">' + esc(pr) + '</span></span>' +
            (one ? '<button type="button" class="cch-rec__b" data-act="rec" data-vid="' + vs[0].id + '" aria-label="Add ' + esc(p.title) + '">Add</button>'
                 : '<a class="cch-rec__b" href="' + esc(p.url) + '" aria-label="Choose a size for ' + esc(p.title) + '">Choose</a>') + '</li>';
        }).join('');
        el.recs.hidden = false;
      };
      if (this.recCache[pid]) { go(this.recCache[pid]); return; }
      fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { self.recCache[pid] = j.products || []; if (self.cart && self.cart.items === items) go(self.recCache[pid]); })
        .catch(function () { el.recs.hidden = true; });
    }
    addRec(b) {
      var self = this; b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…';
      post('cart/add.js', { items: [{ id: parseInt(b.dataset.vid, 10), quantity: 1 }] })
        .then(function () { self.say('Added to cart'); return self.refresh(); })
        .then(function () { self.refreshSoon(); })
        .catch(function (e) { b.removeAttribute('aria-busy'); b.textContent = 'Add'; self.say(e.message); });
    }
  }
  customElements.define('cch-cart-drawer', CchCartDrawer);
})();
